import * as React from 'react';

import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';

export interface ButtonDropDownListItem {
  label: string;
  onClick: () => void;
  active?: boolean;
}

interface Props {
  label: string;
  items: ButtonDropDownListItem[];
  /** Optional additional classes applied to the floating panel */
  className?: string;
}

export const ButtonDropdown: React.FC<Props> = (props) => {
  const { label, items, className } = props;

  return (
    <Menu as="div" className="relative inline-block text-left">
      {({ open }) => (
        <>
          <div>
            <Menu.Button
              className={`flex items-center space-x-5 rounded-md bg-white border border-gray-300 p-2 transition text-sm
              ${open ? 'text-gray-900 ring ring-blue-400 border-opacity-0' : 'text-gray-500'} `}
            >
              <h4>{label}</h4>
              <ChevronDownIcon className="w-5 text-gray-400" />
            </Menu.Button>
          </div>

          <Transition
            as={React.Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items
              className={`absolute left-0 z-10 mt-2 py-1 origin-top-left rounded-md bg-white shadow-lg focus:outline-none ${className}`}
            >
              {items.map((item) => (
                <Menu.Item key={item.label}>
                  <div
                    className={`text-left cursor-pointer px-4 py-2 font-medium w-full whitespace-nowrap text-sm  hover:bg-gray-100 hover:text-gray-900 ${
                      item.active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                    }`}
                    onClick={item.onClick}
                  >
                    {item.label}
                  </div>
                </Menu.Item>
              ))}
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  );
};
ButtonDropdown.displayName = 'ButtonDropdown';
